export const CART_READY = 'CART_READY';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const ADD_DISCOUNT = 'ADD_DISCOUNT';
export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';

export const CUSTOMER_READY = 'CUSTOMER_READY';
export const CUSTOMER_LOGIN = 'CUSTOMER_LOGIN';
export const CUSTOMER_LOGOUT = 'CUSTOMER_LOGOUT';

export const ROUTE_CHANGE = 'ROUTE_CHANGE';

// ideas:
//
// LOADING
// ERROR_THROWN
